import rootReducer from 'reducers';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

export const userLogout = () => {
  store.dispatch({
    type: 'LOGOUT_SUCCESS',
    payload: { status: 'success', action: '' },
  });
};

export const getLanguages = () => {
  return store.getState().propertyReducer.languages;
};

export const getOtaCodes = () => {
  return store.getState().propertyReducer.otaCodes;
};

export const getUserDetails = () => {
  return store.getState().loginReducer.userDetail;
};

export default store;
